import React from 'react'
import styled from '@emotion/styled'
import moment from 'moment'
import { isNil } from 'lodash-es'
import { AuditDetail, NegotiationDetail, NegotiationStatus } from 'api'
import { TicketHeader } from 'view/shared/ticket'
import { CountdownTimer } from 'view/components/timers'
import { DialogRow } from 'view/components/inputs'
import { LiveLockRenderer } from '../LiveNegotiationsGrid/LiveLockRenderer'
import { isNegotiationHistory, isTerminalStatus } from '../shared/utils'
import { Locale, Translation } from 'locale'
import * as constants from 'view/styles/constants'

interface RFQTicketHeaderProps {
  negotiationDetail: NegotiationDetail | AuditDetail
}

const CompetitorLabel = styled.span`
  opacity: 0.9;
  font-weight: normal !important;
`

const TicketLiveLockRenderer = styled(LiveLockRenderer)`
  margin-top: -3px;

  button span {
    align-items: center !important;
    white-space: nowrap;
    font-weight: ${constants.FontWeight.Normal} !important;
  }
`

export class RFQTicketHeader extends React.Component<RFQTicketHeaderProps> {
  render() {
    const { negotiationDetail } = this.props
    const { negotiation, ownOrder } = negotiationDetail

    if (negotiation.status === NegotiationStatus.CANCELLED) {
      return (
        <TicketHeader>
          <DialogRow horizontalLayout={constants.HorizontalLayout.Center}>
            {Locale.translate(Translation.SC_ORIGINAL_RFQ_CANCELLED)}
          </DialogRow>
        </TicketHeader>
      )
    } else if (isNegotiationHistory(negotiation) || isTerminalStatus(negotiation.status)) {
      return null
    } else if (ownOrder) {
      return (
        <TicketHeader>
          <DialogRow horizontalLayout={constants.HorizontalLayout.Center}>
            <CountdownTimer
              expiryTime={moment(negotiation.rfqEndTime)}
              hideIcon={true}
              label={Locale.translate(Translation.SC_ORIGINAL_RFQ_TIME_REMAINING)}
            />
          </DialogRow>
        </TicketHeader>
      )
    } else {
      return (
        <TicketHeader>
          <DialogRow horizontalLayout={constants.HorizontalLayout.SpaceBetween}>
            <span>
              <CompetitorLabel>{Locale.translate(Translation.SC_COMPETITORS)}</CompetitorLabel>
              {negotiation.hideCompetition || isNil(negotiation.competitionCount) ? 0 : negotiation.competitionCount}
            </span>
            <TicketLiveLockRenderer negotiationDetail={negotiationDetail as NegotiationDetail} fullLabel={true} />
          </DialogRow>
        </TicketHeader>
      )
    }
  }
}
